import { data, init, tag } from '@blotoutio/edgetag-sdk-js'

import { ANALYTIC_COOKIES, DEFAULT_CURRENCY_CODE, QUINCE_DOMAIN } from '@src/quince-site-common/src/utils/constants'
import getCookie from '@src/quince-site-common/src/utils/getCookie'
import { getlbUserId } from '@src/quince-site-common/src/utils/getlb-user-id'
import { TelemetryIntegration } from '@src/telemetry/telemetry-events.types'

import { TELEMETRY_DOMAINS } from '../../telemetry-domains.constants'
import { TELEMETRY_EVENT_NAMES } from '../../telemetry-events.constants'
import { processImageUrl } from '../provider-utils/data-layer-pixel-utils'
import { initializeScript } from '../provider-utils/initialize-script'

interface EventProperties {
  productId: string
  quantity: number
  price: number
  variantId: string
  sku: string
  productTitle: string
  variantTitle: string
  description: string
  productType: string
  variantImageUrl: string
  slug: string
  department: string
  shopifyProductId: string | number
  eventId: string
}

interface SearchEventProperties {
  searchQuery: string
  eventId: string
}

export const setUserData = (user: { id: string; email: string }) => {
  data({
    ...user,
  })
}

export const EdgeTag: TelemetryIntegration = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
    domain: TELEMETRY_DOMAINS.EDGE_TAG,
  },

  initialize: async () => {
    await initializeScript({
      key: 'tracking-provider-edgetag',
      domain: TELEMETRY_DOMAINS.EDGE_TAG,
      path: '/edgetagevents.js',
      init: () => {
        init({ edgeURL: TELEMETRY_DOMAINS.EDGE_TAG, disableConsentCheck: true })
        tag('PageView')
      },
    })
  },

  events: {
    [TELEMETRY_EVENT_NAMES.ADD_TO_CART]: properties => {
      logEdgeTagEvent('AddToCart', properties)
    },

    [TELEMETRY_EVENT_NAMES.PRODUCT_VIEW]: properties => {
      logEdgeTagEvent('ViewContent', properties)
    },

    [TELEMETRY_EVENT_NAMES.REMOVE_FROM_CART]: properties => {
      logEdgeTagEvent('RemoveFromCart', properties)
    },

    [TELEMETRY_EVENT_NAMES.SEARCH]: (properties: SearchEventProperties) => {
      // setUserProperties()
      tag('Search', {
        searchQuery: properties.searchQuery,
        currency: DEFAULT_CURRENCY_CODE,
        eventTime: Date.now(),
        visitorId: getlbUserId()?.trim() ?? '',
        sessionId: getCookie(ANALYTIC_COOKIES.SESSION_ID),
        eventId: properties.eventId,
      })
    },
  },
}

const logEdgeTagEvent = (eventType: string, properties: EventProperties) => {
  const content = {
    id: eventType === 'RemoveFromCart' ? String(properties.shopifyProductId) : String(properties.productId),
    quantity: properties.quantity || 1,
    item_price: formatRevenue(properties.price),
    variantId: String(properties.variantId),
    sku: properties.sku,
    title: properties.productTitle + (properties.variantTitle ? ` - ${properties.variantTitle}` : ''),
    category: properties.department,
    brand: 'Quince',
    type: properties.variantId ? 'product' : 'product_group',
    image: processImageUrl(properties.variantImageUrl),
    url: getProductURL(properties.slug),
  }

  // setUserProperties()

  tag(eventType, {
    currency: DEFAULT_CURRENCY_CODE,
    value: formatRevenue(properties.price * (properties.quantity || 1)),
    contents: [content],
    visitorId: getlbUserId()?.trim() ?? '',
    sessionId: getCookie(ANALYTIC_COOKIES.SESSION_ID),
    eventTime: Date.now(),
    quinceEventId: properties.eventId,
  })
}

export const formatRevenue = (price: number | null) => {
  return price ?? 0
}

export const getProductURL = (slug: string) => QUINCE_DOMAIN + '/' + slug

// TODO: Add this back in when we need to make the user data call
// const setUserProperties = () => {
//   const userEmail = getCookie(ANALYTIC_COOKIES.LB_CUSTOMER_EMAIL)

//   userEmail && setUserData({ id: getlbUserId()?.trim() ?? '', email: userEmail })
// }
